import React, { useContext, useEffect, useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import About from '../pages/about';
import UserProfile from '../pages/Profile/UserProfile';
import SignIn from '../pages/SignIn/SignIn';
import CreateDemat from '../pages/Profile/CreateDemat/CreateDemat';
import useAuth from '../services/authContext';
import Home from '../pages/home/home';
import Transactions from '../pages/Transactions/Transaction';
import IPOIndex from '../pages/IPOSubscription/IPOindex';
import { Context } from '../services/apiContext';
import ErrorComponent from '../pages/ErrorComponent/ErrorComponent';
import Referal from '../pages/Referal/Referal';
import ReferGuest from '../pages/ReferGuest/ReferGuest';
import LandingPage from '../pages/referlandingpage/landingpage';
import ReferSignIn from '../pages/SignIn/ReferSignIn';
import UploadPage from '../pages/Admin/upload/UploadPage';
import LoginPage from '../pages/Admin/Login/LoginPage';
import { Provider } from "react-redux";
import store from '../store/Admin/store'
import AdminAppRoutes from './Admin/AdminAppRoutes'

function PrivateRoute({ children }) {
  const { authed } = useAuth();
  // console.log(authed);
  return authed ? children : <Navigate to='/signin' />;
}

function ReferrerRoute({ children }) {
  const { referrer } = useAuth();
  // console.log(authed);
  return referrer ? children : <Navigate to='/signin' />;
}

const Routespaths = () => {
  const contextapi = useContext(Context);
  const [isloginReady, setIsloginReady] = useState(false);
  const { login } = useAuth();
  const [allowRefer, setAllowRefer] = useState();

  useEffect(() => {
    if (contextapi.getSession('cseData')) {
      setAllowRefer(false);
    } else {
      setAllowRefer(true);
    }

    if (contextapi.getSession('access_token')) {
      login().then(() => {
        setIsloginReady(true);
      });
    } else {
      setIsloginReady(true);
    }
  });

  return (
    <div className='App'>
      {isloginReady && allowRefer !== undefined && (
        <Routes>
          <Route name='default' path='' element={<Navigate to='signIn' />} />
          <Route name='about' path='about' element={<About />} />
          <Route name='signIn' path='signIn' element={<SignIn />} />
          <Route name='refer-earn' path='refer-earn' element={<LandingPage />} />
          <Route name='refer-SignIn' path='refer-SignIn' element={<ReferSignIn />} />
          <Route
            name='userProfile'
            path='UserProfile'
            element={
              <PrivateRoute>
                <UserProfile isfromDashBoard={false} />
              </PrivateRoute>
            }
          />
          {allowRefer && (
            <Route
              name='refer'
              path='refer'
              element={
                <ReferrerRoute>
                  <ReferGuest isfromDashBoard={false} />
                </ReferrerRoute>
              }
            />
          )}
          {allowRefer && (
            <Route
              name='referral'
              path='referral'
              element={
                <PrivateRoute>
                  <Referal isfromDashBoard={false} />
                </PrivateRoute>
              }
            />
          )}

          <Route
            path='home/*'
            element={
              <PrivateRoute>
                <Home />
              </PrivateRoute>
            }
          />

          <Route path='createDemat/*' element={<CreateDemat />} />
          <Route path='Transactions/*' element={<Transactions />} />
          <Route path='IPO/*' element={<IPOIndex />} />

          <Route path='admin/mis-recon/*' element={ <AdminAppRoutes /> }/>

          <Route path='*' exact={true} element={<ErrorComponent />} />
          {/* <SideNav /> */}
        </Routes>
      )}
      {/* <SideNav /> */}
    </div>
  );
};

export default Routespaths;
